import React from "react";
import { cardWithItems } from "./Card";

const items = [
  {
    title: "ID",
    value: "id",
    full: true
  },
  {
    title: "Client ID",
    value: "clientId",
    full: true
  },
  {
    title: "Name",
    value: "name"
  },
  {
    title: "Trial Duration",
    value: "trialDuration"
  }
];

class AppCard extends React.Component {
  render = () => "";
}

export default cardWithItems(AppCard, items);



// WEBPACK FOOTER //
// ./src/library/card/AppCard.js